import React from "react";
import { Clock, DollarSign, ShoppingBag, TrendingUp } from "lucide-react";

import { formatCurrency, formatInt } from "../lib/formato";
import Comparacao from "./Comparacao";

const TEMAS = {
  violet: { caixa: "from-violet-50 to-purple-50 dark:from-violet-900/20 dark:to-purple-900/20 border-violet-200 dark:border-violet-800",
    titulo: "text-violet-600 dark:text-violet-400", valor: "text-violet-700 dark:text-violet-300", linha: "border-violet-200/50 dark:border-violet-700/30" },
  green: { caixa: "from-green-50 to-emerald-50 dark:from-green-900/20 dark:to-emerald-900/20 border-green-200 dark:border-green-800",
    titulo: "text-green-600 dark:text-green-400", valor: "text-green-700 dark:text-green-300", linha: "border-green-200/50 dark:border-green-700/30" },
  purple: { caixa: "from-purple-50 to-violet-50 dark:from-purple-900/20 dark:to-violet-900/20 border-purple-200 dark:border-purple-800",
    titulo: "text-purple-600 dark:text-purple-400", valor: "text-purple-700 dark:text-purple-300", linha: "border-purple-200/50 dark:border-purple-700/30" },
  teal: { caixa: "from-teal-50 to-cyan-50 dark:from-teal-900/20 dark:to-cyan-900/20 border-teal-200 dark:border-teal-800",
    titulo: "text-teal-600 dark:text-teal-400", valor: "text-teal-700 dark:text-teal-300", linha: "border-teal-200/50 dark:border-teal-700/30" },
};

function Card({ tema, titulo, icon: Icon, valor, rodape, children }) {
  const t = TEMAS[tema];
  return (
    <div className={`bg-gradient-to-br rounded-xl border p-4 ${t.caixa}`} data-e2e={`kpi-${tema}`}>
      <div className="flex items-center justify-between mb-1">
        <p className={`text-xs font-medium ${t.titulo}`}>{titulo}</p>
        <Icon className={`w-4 h-4 ${t.titulo}`} />
      </div>
      <p className={`text-2xl lg:text-3xl font-bold tabular-nums ${t.valor}`}>{valor}</p>
      {children}
      {rodape && <div className={`flex flex-wrap items-center gap-x-3 gap-y-0.5 mt-2 pt-2 border-t ${t.linha}`}>{rodape}</div>}
    </div>
  );
}

const minutos = (v) => `${formatInt(v)} min`;

// Os 4 cartões do topo. Tudo aqui é DO PERÍODO escolhido — inclusive ticket
// médio e entregas, que até 21/09/2026 eram da loja inteira (achado 76).
export default function CardsKpi({ dados }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      <Card tema="violet" titulo="Pedidos" icon={ShoppingBag} valor={formatInt(dados.pedidos_totais)}
        rodape={<>
          <span className="text-[10px] text-red-500 dark:text-red-400">{formatInt(dados.pedidos_cancelados)} cancelados</span>
          <span className="text-[10px] text-muted-foreground">{formatInt(dados.entregas)} entregas</span>
        </>}>
        <Comparacao dados={dados} kpi="pedidos" chave="pedidos" formatar={formatInt} />
      </Card>
      <Card tema="green" titulo="Faturamento" icon={DollarSign} valor={formatCurrency(dados.faturamento_periodo)}
        rodape={<span className="text-[10px] text-muted-foreground">Taxas de entrega: {formatCurrency(dados.valor_entregas)}</span>}>
        <Comparacao dados={dados} kpi="faturamento" chave="faturamento" formatar={formatCurrency} />
      </Card>
      <Card tema="purple" titulo="Ticket Médio" icon={TrendingUp} valor={formatCurrency(dados.ticket_medio)}
        rodape={<span className="text-[10px] text-muted-foreground">faturamento ÷ pedidos não cancelados</span>}>
        <Comparacao dados={dados} kpi="ticket_medio" chave="ticket" formatar={formatCurrency} />
      </Card>
      <Card tema="teal" titulo="Tempo Médio" icon={Clock} valor={minutos(dados.tempo_medio)}
        rodape={<span className="text-[10px] text-muted-foreground">da criação à conclusão do pedido</span>}>
        <Comparacao dados={dados} kpi="tempo_medio" chave="tempo" formatar={minutos} menorMelhor />
      </Card>
    </div>
  );
}
